import React, { useState } from 'react';
import MfaResult from '../../../models/MfaResult';
import { sleep } from '../../../utils';
import { Button } from '../../core/button';
import { Field } from '../../core/field';
import styles from '../login.module.scss';
import { loginMfaCode } from './service';

type Props = {
  metadata: MfaResult;
  onAuthorized: () => void;
}

export const MfaForm: React.FC<Props> = ({ metadata, onAuthorized }) => {
  const [mfaCode, setMfaCode] = useState('');
  const [busy, setBusy] = useState(false);

  const inputValid = mfaCode?.length === 6;

  async function submit() {
    if (busy || !inputValid) {
      return;
    }
    setBusy(true);

    while (true) {
      var success = false;
      try {
        await loginMfaCode(mfaCode);
        var success = true;
        break;
      } catch (e) {
        console.error(e);

        if (e.status === 401) {
          break;
        }

        await sleep(2500);
      }
    }

    if (success) {
      onAuthorized();
    }

    setBusy(false);
  }

  return (
    <form
      className={styles.form}
      onSubmit={e => {
        e.preventDefault();
        submit();
        return false;
      }}>
      <h3 className={styles.title}>
        Tvåstegsverifiering
      </h3>

      {
        metadata.emailRecipient ? (
          <p>Skickat till {metadata.emailRecipient}</p>
        ) : null
      }

      <Field
        label="Kod (6 tecken)"
        maxLength={6}
        value={mfaCode}
        onTextValueChange={setMfaCode}
      />

      <Button type="submit" weight="primary" disabled={!inputValid}>
        Logga in
      </Button>
    </form>
  );
}